import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}
export const SelectBudgetIDType = ({ idSelector, onChange, label }: Props) => {

    const service = new FinanceService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(NaN);

    useEffect(() => {
        if (idSelector)
            setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }

    const getLista = () => {



        service.getBudgetIDTypeCatalog(null).subscribe(
            (resp: any) => {



                if (resp.DataBeanProperties.ObjectValue) {
                    const response = resp.DataBeanProperties.ObjectValue;
                    setLista(response);
                    const exists = response.some((item: any) => item.DataBeanProperties.IDBudgetIDType === idSelector);
                    if ((!idSelector || !exists) && response.length > 0) {
                        const firstId = response[0].DataBeanProperties.IDBudgetIDType;
                        setID(firstId);
                        onChange(firstId);
                    } else if (idSelector) {
                        setID(idSelector);
                    }
                }
            }
        );
    }

    return (
        <>
            <label>{label ?? "Tipos de Catálogo Presupuestal"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                {/* <option value={0}>...</option> */}
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.IDBudgetIDType} value={item.DataBeanProperties.IDBudgetIDType} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}